import React from 'react';
import { Wrench, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-slate-900 text-white py-12" data-id="element-122">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center" data-id="element-123">
        <div className="mb-8" data-id="element-124">
          <h3 className="text-2xl font-bold mb-2" data-id="element-125">Megapack NutriEficiente</h3>
          <p className="text-slate-400" data-id="element-126">
            Sistema profesional para nutricionistas
          </p>
        </div>

        {/* Support section */}
        <div className="bg-slate-800 rounded-2xl p-6 mb-8 max-w-md mx-auto border border-slate-700" data-id="element-127">
          <div className="inline-flex items-center gap-2 bg-emerald-600 text-white px-4 py-1.5 rounded-full text-xs font-bold mb-3" data-id="element-128">
            <Wrench className="w-3.5 h-3.5" data-id="element-129" />
            SOPORTE
          </div>
          <p className="text-slate-300 text-sm mb-3" data-id="element-130">
            ¿Tenés alguna duda o necesitás ayuda?
          </p>
          <a href="mailto:ebookdreamshop@gmail.com" className="inline-flex items-center gap-2 text-emerald-400 hover:text-emerald-300 font-semibold transition-colors duration-200" data-id="element-131">
            <Mail className="w-4 h-4" data-id="element-132" />
            ebookdreamshop@gmail.com
          </a>
        </div>

        <div className="border-t border-slate-700 pt-6" data-id="element-133">
          <p className="text-slate-400 text-sm mb-4" data-id="element-134">
            © {new Date().getFullYear()} Megapack NutriEficiente. Todos los
            derechos reservados.
          </p>
          <p className="text-slate-500 text-xs max-w-2xl mx-auto" data-id="element-135">
            Este producto es un material educativo digital. Los resultados
            pueden variar según la aplicación individual. No sustituye la
            formación profesional ni la consulta con especialistas.
          </p>
        </div>
      </div>
    </footer>;
}